import { applicationApi } from "../../../common/api";
import { ApprovalSignatureUpsert, SubmissionAssessmentConfig } from './type';

// Define a service using a base URL and expected endpoints
export const submissionConfigApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalAssessment: builder.query<SubmissionAssessmentConfig[], void>({
      query: () => `loans-submission/assessment-config/personal`,
      providesTags: [{ type: 'SubmissionConfig-Personal', id: 'LIST' }],
    }),
    getFiveCWorkAssessment: builder.query<SubmissionAssessmentConfig[], void>({
      query: () => `loans-submission/assessment-config/five-c-work`,
      providesTags: [{ type: 'SubmissionConfig-FiveC', id: 'LIST' }],
    }),
    getFiveCBusinessAssessment: builder.query<SubmissionAssessmentConfig[], void>({
      query: () => `loans-submission/assessment-config/five-c-business`,
      providesTags: [{ type: 'SubmissionConfig-FiveC', id: 'LIST' }],
    }),
    getSubmissionAssessmentConfig: builder.query<SubmissionAssessmentConfig, string>({
      query: (query) => `loans-submission/assessment-config/${query}`,
    }),
    creaseSubmissionAssessment: builder.mutation<SubmissionAssessmentConfig, any>({
      query: (body) => ({
        url: 'loans-submission/assessment-config',
        method: 'POST',
        body,
      }),
      invalidatesTags: [
        { type: 'SubmissionConfig-Personal', id: 'LIST' },
        { type: 'SubmissionConfig-FiveC', id: 'LIST' },
      ],
    }),
    deleteSubmissionAssessment: builder.mutation<any, number>({
      query: (id) => ({
        url: `loans-submission/assessment-config/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        { type: 'SubmissionConfig-Personal', id: 'LIST' },
        { type: 'SubmissionConfig-FiveC', id: 'LIST' },
      ],
    }),
    updateSubmissionAssessment: builder.mutation<SubmissionAssessmentConfig, any>({
      query: (body) => ({
        url: `loans-submission/assessment-config/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [
        { type: 'SubmissionConfig-Personal', id: 'LIST' },
        { type: 'SubmissionConfig-FiveC', id: 'LIST' },
      ],
    }),
    getApprovalSignatureConfig: builder.query<number[], string>({
      query: (query) => `config/getByKey/${query}`,
    }),
    updateApprovalSignatureConfig: builder.mutation<ApprovalSignatureUpsert, any>({
      query: (body) => ({
        url: 'config',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'ApprovalSignatureConfig', id: 'LIST' }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPersonalAssessmentQuery,
  useGetFiveCWorkAssessmentQuery,
  useGetFiveCBusinessAssessmentQuery,
  useGetSubmissionAssessmentConfigQuery,
  useCreaseSubmissionAssessmentMutation,
  useUpdateSubmissionAssessmentMutation,
  useDeleteSubmissionAssessmentMutation,
  useUpdateApprovalSignatureConfigMutation,
  useGetApprovalSignatureConfigQuery,
} = submissionConfigApi;
